import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const RutgersUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Rutgers University"
      universityShortName="Rutgers"
      slug="rutgers-university"
      seoTitle="Rutgers Study Rooms | New Brunswick Library Study Spaces"
      seoDescription="Find study rooms at Rutgers including Alexander Library and Art Library. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="Rutgers study rooms, Rutgers University library, New Brunswick study spaces, Scarlet Knight study rooms, Alexander Library"
      canonicalUrl="/study-room/rutgers-university/"
      heroDescription="Navigate Rutgers' multi-campus library system for the best study spaces."
      libraryWebsiteUrl="https://www.libraries.rutgers.edu"
      libraryWebsiteName="Rutgers Libraries"
      studySpaces={[
        {
          name: "Art Library - Group Room",
          features: "8 seats, monitor and whiteboard, up to 3 hours/day. NetID required.",
          feedback: "Good tech setup. Food and drink allowed except in special collections."
        },
        {
          name: "Alexander Library - Upper Floors",
          features: "Quiet study environment, individual desks and carrels.",
          feedback: "Best for focused solo work. Less crowded than lower floors."
        },
        {
          name: "Douglass Campus Library",
          features: "Limited study room availability, smaller campus library.",
          feedback: "Fewer spaces available. Sound carries through walls."
        },
        {
          name: "Cook Campus Center",
          features: "Informal study spaces with large tables and natural light.",
          feedback: "Great alternative when library rooms are full."
        }
      ]}
      guideContent={
        <>
          <p>
            Rutgers libraries offer group study rooms across campuses. In the Art Library, a room with eight seats, 
            a monitor and whiteboard can be reserved for up to three hours per day. Booking requires a NetID.
          </p>
          <p className="mt-4">
            Food and drink are allowed except in special collections areas. Students note that there are limited 
            spaces at Douglass Campus library, and some note that sound carries through walls.
          </p>
          <p className="mt-4">
            Plan ahead when booking because high demand limits availability. For a quiet environment, choose 
            Alexander Library's upper floors. When group study rooms are full, the Cook Campus Center provides 
            informal study spaces with large tables and natural light.
          </p>
        </>
      }
      summaryTips={[
        "Book with NetID up to 3 hours per day",
        "Art Library has monitor and whiteboard",
        "Alexander Library upper floors are quietest",
        "Sound carries through walls in some rooms",
        "Cook Campus Center is a good backup option"
      ]}
    />
  );
};

export default RutgersUniversity;
